import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import { Icon } from '@iconify/react';

const FiltroFechas = ({
  onDesdeDate,
  onHastaDate,
  handleResetFechas,
  hastaDate,
  desdeDate,
  onlyhandleResetFechas = false
}) => {
  const resetDates = () => {
    onDesdeDate({ target: { value: '' } });
  };

  const handleHastaDate = (event) => {
    const selectedDate = event.target.value;

    onHastaDate({ target: { value: selectedDate } });
  };

  return (
    <Box sx={{ display: 'flex', gap: '10px' }}>
      <TextField
        type="date"
        label="Desde"
        onChange={onDesdeDate}
        InputLabelProps={{
          shrink: true
        }}
        value={desdeDate}
      />

      <TextField
        type="date"
        label="Hasta"
        onChange={handleHastaDate}
        InputLabelProps={{
          shrink: true
        }}
        value={hastaDate}
      />
      <Tooltip
        title="Limpiar fechas"
        onClick={() => {
          handleResetFechas();
          if (!onlyhandleResetFechas) resetDates();
        }}
      >
        <IconButton>
          <Icon icon="ic:baseline-clear" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FiltroFechas;
